module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-container"
  }, [_c('div', {
    staticClass: "contact"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "contact__items row text-center justify-content-center"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-2"
  }, [_c('a', {
    attrs: {
      "href": "https://www.google.com.hk/maps/place/SOUTHMARK/@22.249049,114.1643218,19z/data=!4m5!3m4!1s0x34040018d827732b:0xbba21061bdcde893!8m2!3d22.249044!4d114.164869?hl=zh",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "symbol"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/locationSymbol.png"),
      "srcset": _vm.ls2x + ' 2x'
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n            香港黃竹坑業興街 11 號南匯廣場 A 座 23 樓\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2"
  }, [_c('a', {
    attrs: {
      "href": "tel:+852 28959515"
    }
  }, [_c('div', {
    staticClass: "symbol"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/telSymbol.png"),
      "srcset": _vm.ts2x + ' 2x'
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n            查詢熱線\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            2895 9515\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/Combat.HK/",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "symbol"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/facebookSymbol.png"),
      "srcset": _vm.fs2x + ' 2x'
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n            Facebook\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact__title row text-center"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n        聯絡我們\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact__subtitle row text-center"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n        DKSH Hong Kong Limited\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n        大昌華嘉香港有限公司\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ce7e4d8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/Contact.vue
// module id = 230
// module chunks = 0